// import React from "react";
// import "./Support.css"; // Import your custom styles

// const Support = () => {
//   const query_dp = `${process.env.PUBLIC_URL}/custom-icons/query-dp.png`; // Path to the main image
//   const helpIcon =  `${process.env.PUBLIC_URL}/custom-icons/query_pink.png`; // Path to help icon
//   const phoneIcon = `${process.env.PUBLIC_URL}/custom-icons/phone.png`; // Path to phone icon
//   const emailIcon = `${process.env.PUBLIC_URL}/custom-icons/email.png`; // Path to email icon

//   return (
//     <div className="support-container">
//       <div className="support-popup-image">
//         <img src={query_dp} alt="Support" className="support-image" />
//       </div>
//       <div className="support-popup-text">
//         <h3>Support</h3>
//         <p>If you need any help, contact us</p>
//         <div className="support-details">
//           <div className="support-item">
//             <img src={helpIcon} alt="Help Desk" className="support-icon" />
//             <span className="support-link">Help desk</span>
//           </div>
//           <div className="support-item">
//             <img src={phoneIcon} alt="Phone" className="support-icon" />
//             <span className="support-link">+919810498126</span>
//           </div>
//           <div className="support-item">
//             <img src={emailIcon} alt="Email" className="support-icon" />
//             <span className="support-link">hello@surveyorsai.com</span>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Support;
import React from "react";
import "./Support.css"; // Import your custom styles
import PublicIcon from "@mui/icons-material/Public";
import { Link } from "@mui/material"
const Support = () => {
  const query_dp = `${process.env.PUBLIC_URL}/custom-icons/query-dp.png`; // Path to the main image
  const helpIcon = `${process.env.PUBLIC_URL}/custom-icons/query_pink.png`; // Path to help icon
  const phoneIcon = `${process.env.PUBLIC_URL}/custom-icons/phone.png`; // Path to phone icon
  const emailIcon = `${process.env.PUBLIC_URL}/custom-icons/email.png`; // Path to email icon

  return (
    <div className="support-container">
      <div className="support-popup-image">
        <img src={query_dp} alt="Support" className="support-image" />
      </div>
      <div className="support-popup-text">
        <h3>Support</h3>
        <p>If you need any help, contact us.</p>
        <div className="support-details">
          <div className="support-item">
            <img src={helpIcon} alt="Help Desk" className="support-icon" />
            <a
              // href="https://surveyorsai.com"
              // target="_blank"
              rel="noopener noreferrer"
              className="support-link"
            >
              Help Desk
            </a>
          </div>
          {/* <div className="support-item" style={{ display: "flex", alignItems: "center" }}>
            <PublicIcon style={{ color: "#ff0083", marginRight:"7px" }} fontSize="medium" />
            <Link
              href="https://surveyorsai.com"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              style={{ fontSize: "16px", color: "#ff0083", textDecoration: "none",fontFamily:'Montserrat' }}
            >
              Website
            </Link>
          </div> */}
          <div className="support-item">
            <img src={phoneIcon} alt="Phone" className="support-icon" />
            <a href="tel:+919810498126" className="support-link">
              +91 9810498126
            </a>
          </div>
          <div className="support-item">
            <img src={emailIcon} alt="Email" className="support-icon" />
            <a href="mailto:care@surveyorsai.com" className="support-link">
              care@surveyorsai.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
